module.exports = __webpack_public_path__ + "img/soundcloud.9f670258.svg";